module.exports = __webpack_public_path__ + "img/fy5.ce666b25.png";